// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PatientDetailsNavigation-module__font-s-10___mxlze {
  font-size: 10px !important;
}

.PatientDetailsNavigation-module__font-s-12___L4wzv {
  font-size: 12px !important;
}

.PatientDetailsNavigation-module__font-s-13___hqXKI {
  font-size: 13px !important;
}

.PatientDetailsNavigation-module__font-s-14___AFIrC {
  font-size: 14px !important;
}

.PatientDetailsNavigation-module__font-s-15___lLlGR {
  font-size: 15px !important;
}

.PatientDetailsNavigation-module__font-s-16___nFvW9 {
  font-size: 16px !important;
}

.PatientDetailsNavigation-module__font-s-18___Xdhpj {
  font-size: 18px !important;
}

.PatientDetailsNavigation-module__font-s-20___etu7O {
  font-size: 20px !important;
}

.PatientDetailsNavigation-module__font-s-22___QTtKe {
  font-size: 22px !important;
}

.PatientDetailsNavigation-module__font-s-28___hSuFY {
  font-size: 28px !important;
}

.PatientDetailsNavigation-module__font-w-400___WIqYk {
  font-weight: 400 !important;
}

.PatientDetailsNavigation-module__font-w-500___Azq45 {
  font-weight: 500 !important;
}

.PatientDetailsNavigation-module__font-w-600___jO86B {
  font-weight: 600 !important;
}

.PatientDetailsNavigation-module__font-w-700___qTATm {
  font-weight: 700 !important;
}

.PatientDetailsNavigation-module__p-5___QbxwL {
  padding: 5px !important;
}

.PatientDetailsNavigation-module__p-12___L5IPT {
  padding: 12px !important;
}

.PatientDetailsNavigation-module__p-16___pkc_h {
  padding: 16px !important;
}

.PatientDetailsNavigation-module__p-30___fffoF {
  padding: 30px !important;
}

.PatientDetailsNavigation-module__p-b-0___glRpy {
  padding-bottom: 0 !important;
}

.PatientDetailsNavigation-module__p-b-5___ZMKYP {
  padding-bottom: 5px !important;
}

.PatientDetailsNavigation-module__p-b-10___S6BXQ {
  padding-bottom: 10px !important;
}

.PatientDetailsNavigation-module__p-b-12___dkwTK {
  padding-bottom: 12px !important;
}

.PatientDetailsNavigation-module__p-b-16___voxdM {
  padding-bottom: 16px !important;
}

.PatientDetailsNavigation-module__p-b-18___i6Ff1 {
  padding-bottom: 18px !important;
}

.PatientDetailsNavigation-module__p-b-20___zYscO {
  padding-bottom: 20px !important;
}

.PatientDetailsNavigation-module__p-b-25___lgvE4 {
  padding-bottom: 25px !important;
}

.PatientDetailsNavigation-module__p-b-30___dDNLd {
  padding-bottom: 30px !important;
}

.PatientDetailsNavigation-module__p-b-50___jnAuX {
  padding-bottom: 50px !important;
}

.PatientDetailsNavigation-module__p-t-0___c2eU5 {
  padding-top: 0 !important;
}

.PatientDetailsNavigation-module__p-t-12___SC5BQ {
  padding-top: 12px !important;
}

.PatientDetailsNavigation-module__p-t-16___AXPRw {
  padding-top: 16px !important;
}

.PatientDetailsNavigation-module__p-t-18___dOOuZ {
  padding-top: 18px !important;
}

.PatientDetailsNavigation-module__p-t-20___YgBkh {
  padding-top: 20px !important;
}

.PatientDetailsNavigation-module__p-t-30___x5sfX {
  padding-top: 30px !important;
}

.PatientDetailsNavigation-module__p-t-40___hwxhD {
  padding-top: 40px !important;
}

.PatientDetailsNavigation-module__p-t-50___k4F8a {
  padding-top: 50px !important;
}

.PatientDetailsNavigation-module__p-l-20___Evbvs {
  padding-left: 20px !important;
}

.PatientDetailsNavigation-module__p-l-30___L45sf {
  padding-left: 30px !important;
}

.PatientDetailsNavigation-module__p-l-40___GCLBb {
  padding-left: 40px !important;
}

.PatientDetailsNavigation-module__p-r-16___q7h6t {
  padding-right: 16px !important;
}

.PatientDetailsNavigation-module__p-r-20___9NJcT {
  padding-right: 20px !important;
}

.PatientDetailsNavigation-module__p-r-30___JBITQ {
  padding-right: 30px !important;
}

.PatientDetailsNavigation-module__p-r-50___LKOf0 {
  padding-right: 50px !important;
}

.PatientDetailsNavigation-module__p-r-60___NvnK8 {
  padding-right: 60px !important;
}

.PatientDetailsNavigation-module__m-b-1___ck8yS {
  margin-bottom: 1px !important;
}

.PatientDetailsNavigation-module__m-b-2___Nl3jY {
  margin-bottom: 2px !important;
}

.PatientDetailsNavigation-module__m-b-6___bOBTw {
  margin-bottom: 6px !important;
}

.PatientDetailsNavigation-module__m-b-8___u2Fq_ {
  margin-bottom: 8px !important;
}

.PatientDetailsNavigation-module__m-b-10____fSAP {
  margin-bottom: 10px !important;
}

.PatientDetailsNavigation-module__m-b-14___xKFS9 {
  margin-bottom: 14px !important;
}

.PatientDetailsNavigation-module__m-b-16___nt_oo {
  margin-bottom: 16px !important;
}

.PatientDetailsNavigation-module__m-b-20___EhWoa {
  margin-bottom: 20px !important;
}

.PatientDetailsNavigation-module__m-b-22___lHDcL {
  margin-bottom: 22px !important;
}

.PatientDetailsNavigation-module__m-b-24___ZcMLy {
  margin-bottom: 24px !important;
}

.PatientDetailsNavigation-module__m-b-30___WOsLS {
  margin-bottom: 30px !important;
}

.PatientDetailsNavigation-module__m-b-32___iBnqX {
  margin-bottom: 32px !important;
}

.PatientDetailsNavigation-module__m-b-40___ugcKS {
  margin-bottom: 40px !important;
}

.PatientDetailsNavigation-module__m-t-2___FVPzZ {
  margin-top: 2px !important;
}

.PatientDetailsNavigation-module__m-t-3___WSXos {
  margin-top: 3px !important;
}

.PatientDetailsNavigation-module__m-t-4___H58aA {
  margin-top: 4px !important;
}

.PatientDetailsNavigation-module__m-t-5___OfO4n {
  margin-top: 5px !important;
}

.PatientDetailsNavigation-module__m-t-8___PR6no {
  margin-top: 8px !important;
}

.PatientDetailsNavigation-module__m-t-10___i4iHY {
  margin-top: 10px !important;
}

.PatientDetailsNavigation-module__m-t-15___uvyxv {
  margin-top: 15px !important;
}

.PatientDetailsNavigation-module__m-t-16___0YEUM {
  margin-top: 16px !important;
}

.PatientDetailsNavigation-module__m-t-20___tOxrq {
  margin-top: 20px !important;
}

.PatientDetailsNavigation-module__m-t-22___mXaCM {
  margin-top: 22px !important;
}

.PatientDetailsNavigation-module__m-t-30___HGwpX {
  margin-top: 30px !important;
}

.PatientDetailsNavigation-module__m-t-32___zMWTm {
  margin-top: 32px !important;
}

.PatientDetailsNavigation-module__m-l-auto___jGMFy {
  margin-left: auto !important;
}

.PatientDetailsNavigation-module__m-l-4___fsUCD {
  margin-left: 4px !important;
}

.PatientDetailsNavigation-module__m-l-5___ibEaC {
  margin-left: 5px !important;
}

.PatientDetailsNavigation-module__m-l-6___ODDAE {
  margin-left: 6px !important;
}

.PatientDetailsNavigation-module__m-l-8___uqEzH {
  margin-left: 8px !important;
}

.PatientDetailsNavigation-module__m-l-10___SxGw3 {
  margin-left: 10px !important;
}

.PatientDetailsNavigation-module__m-l-16___DrN3j {
  margin-left: 16px !important;
}

.PatientDetailsNavigation-module__m-l-20___yW5DR {
  margin-left: 20px !important;
}

.PatientDetailsNavigation-module__m-l-24___QSD9G {
  margin-left: 24px !important;
}

.PatientDetailsNavigation-module__m-l-30___nI_DJ {
  margin-left: 30px !important;
}

.PatientDetailsNavigation-module__m-l-35___Q4MFF {
  margin-left: 35px !important;
}

.PatientDetailsNavigation-module__m-l-40___c6NtL {
  margin-left: 40px !important;
}

.PatientDetailsNavigation-module__m-r-8___MNxpb {
  margin-right: 8px !important;
}

.PatientDetailsNavigation-module__m-r-10___X8Pc5 {
  margin-right: 10px !important;
}

.PatientDetailsNavigation-module__m-r-16___k8__s {
  margin-right: 16px !important;
}

.PatientDetailsNavigation-module__m-r-20___fqaVp {
  margin-right: 20px !important;
}

.PatientDetailsNavigation-module__m-r-24___O3TKx {
  margin-right: 24px !important;
}

.PatientDetailsNavigation-module__m-r-30___omjYl {
  margin-right: 30px !important;
}

.PatientDetailsNavigation-module__m-r-40___qXEoT {
  margin-right: 40px !important;
}

.PatientDetailsNavigation-module__border-r-3___zZrUt {
  border-radius: 3px !important;
}

.PatientDetailsNavigation-module__border-r-4___utR5G {
  border-radius: 4px !important;
}

.PatientDetailsNavigation-module__border-r-6___GOA_J {
  border-radius: 6px !important;
}

.PatientDetailsNavigation-module__border-r-10___OvcmH {
  border-radius: 10px !important;
}

.PatientDetailsNavigation-module__border-r-12____FVfM {
  border-radius: 12px !important;
}

.PatientDetailsNavigation-module__border-r-16___x8kLB {
  border-radius: 16px !important;
}

.PatientDetailsNavigation-module__border-r-50___gvZ5d {
  border-radius: 50% !important;
}

.PatientDetailsNavigation-module__primary-border___KU7_3 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetailsNavigation-module__primary-border-b___u4604 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetailsNavigation-module__primary-border-t___knzLf {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetailsNavigation-module__primary-border-l___iXNGF {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetailsNavigation-module__primary-border-r___RNFjg {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetailsNavigation-module__secondary-border___e61Ei {
  border: 1px solid #637768;
}

.PatientDetailsNavigation-module__secondary-border-b___dU21F {
  border-bottom: 1px solid #637768;
}

.PatientDetailsNavigation-module__secondary-border-t___UnVWW {
  border-top: 1px solid #637768;
}

.PatientDetailsNavigation-module__secondary-border-l___m6mpk {
  border-left: 1px solid #637768;
}

.PatientDetailsNavigation-module__secondary-border-r___Z96PU {
  border-right: 1px solid #637768;
}

.PatientDetailsNavigation-module__gap-0___fIUNr {
  gap: 0 !important;
}

.PatientDetailsNavigation-module__gap-2___QCUPh {
  gap: 2px !important;
}

.PatientDetailsNavigation-module__gap-4___wPaZa {
  gap: 4px !important;
}

.PatientDetailsNavigation-module__gap-5___Gwe5G {
  gap: 5px !important;
}

.PatientDetailsNavigation-module__gap-6___vrPiO {
  gap: 6px !important;
}

.PatientDetailsNavigation-module__gap-8___SY3Kr {
  gap: 8px !important;
}

.PatientDetailsNavigation-module__gap-10___O0KxY {
  gap: 10px !important;
}

.PatientDetailsNavigation-module__gap-12___faOFk {
  gap: 12px !important;
}

.PatientDetailsNavigation-module__gap-14___zoofE {
  gap: 14px !important;
}

.PatientDetailsNavigation-module__gap-16___J9o_4 {
  gap: 16px !important;
}

.PatientDetailsNavigation-module__gap-18___CWfMS {
  gap: 18px !important;
}

.PatientDetailsNavigation-module__gap-20___cudxe {
  gap: 20px !important;
}

.PatientDetailsNavigation-module__gap-24___cE2SR {
  gap: 24px !important;
}

.PatientDetailsNavigation-module__gap-26___mYz4R {
  gap: 26px !important;
}

.PatientDetailsNavigation-module__gap-30___lO327 {
  gap: 30px !important;
}

.PatientDetailsNavigation-module__gap-32___r4ZWa {
  gap: 32px !important;
}

.PatientDetailsNavigation-module__gap-40___hVZwG {
  gap: 40px !important;
}

.PatientDetailsNavigation-module__gap-50___OgvUY {
  gap: 50px !important;
}

.PatientDetailsNavigation-module__flex-1___MBqZT {
  flex: 1;
}

.PatientDetailsNavigation-module__flex-none___yGihL {
  flex: none !important;
}

.PatientDetailsNavigation-module__flex-column___HQ4SV {
  display: flex;
  flex-direction: column !important;
}

.PatientDetailsNavigation-module__flex-row___LjyI4 {
  display: flex;
  flex-direction: row !important;
}

.PatientDetailsNavigation-module__vertically-centered___Mt8wk {
  display: flex;
  align-items: center !important;
}

.PatientDetailsNavigation-module__horizontally-centered___mHZ9T {
  display: flex;
  justify-content: center !important;
}

.PatientDetailsNavigation-module__horizontally-end___Xmqxj {
  display: flex;
  justify-content: end !important;
}

.PatientDetailsNavigation-module__vertically-start___ye9p_ {
  display: flex;
  align-items: start !important;
}

.PatientDetailsNavigation-module__space-between____Vu9W {
  display: flex;
  justify-content: space-between !important;
}

.PatientDetailsNavigation-module__flex-wrap___gG4yg {
  flex-wrap: wrap !important;
}

.PatientDetailsNavigation-module__height-100___r9UNh {
  height: 100%;
}

.PatientDetailsNavigation-module__width-50___PWd2_ {
  width: 50% !important;
}

.PatientDetailsNavigation-module__width-100___RpitE {
  width: 100%;
}

.PatientDetailsNavigation-module__cursor-pointer___PqxD3 {
  cursor: pointer;
}

.PatientDetailsNavigation-module__cursor-not-allowed___GGjlU {
  cursor: not-allowed !important;
}

.PatientDetailsNavigation-module__absolute-centered___uXNbd {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.PatientDetailsNavigation-module__absolute___SEies {
  position: absolute;
}

.PatientDetailsNavigation-module__relative___sbPc2 {
  position: relative;
}

.PatientDetailsNavigation-module__fixed___bFZHo {
  position: fixed;
}

.PatientDetailsNavigation-module__visible___XtzkF {
  opacity: 1;
}

.PatientDetailsNavigation-module__invisible___BiAvi {
  opacity: 0;
}

.PatientDetailsNavigation-module__col-90___sNkfI {
  width: 90% !important;
}

.PatientDetailsNavigation-module__col-auto___HJHLZ {
  width: auto !important;
}

.PatientDetailsNavigation-module__medical-tabs___FLqO0 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.PatientDetailsNavigation-module__medical-table-new___XeHFh {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientDetailsNavigation-module__medical-table-new___XeHFh:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientDetailsNavigation-module__medical-table-new___XeHFh::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientDetailsNavigation-module__medical-table-new___XeHFh::-webkit-scrollbar-track {
  display: none;
}
.PatientDetailsNavigation-module__medical-table-new___XeHFh.PatientDetailsNavigation-module__no-pagination___MQ_Qx {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientDetailsNavigation-module__medical-table-new___XeHFh.PatientDetailsNavigation-module__no-pagination___MQ_Qx:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientDetailsNavigation-module__medical-table-new___XeHFh.PatientDetailsNavigation-module__no-pagination___MQ_Qx::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientDetailsNavigation-module__medical-table-new___XeHFh.PatientDetailsNavigation-module__no-pagination___MQ_Qx::-webkit-scrollbar-track {
  display: none;
}

.PatientDetailsNavigation-module__medical-table-empty___UkUr1 {
  padding: 14px 40px !important;
}

.PatientDetailsNavigation-module__icon-btn___dADUP {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.PatientDetailsNavigation-module__search-icon___B2lE8 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.PatientDetailsNavigation-module__disable-select___avU92 {
  user-select: none;
}

.PatientDetailsNavigation-module__break-word___eqAxS {
  word-break: break-word;
}

.PatientDetailsNavigation-module__popup-clear-btn___eIlX5 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.PatientDetailsNavigation-module__scroll-m-b-20___J3EZi {
  scroll-margin-bottom: 20px;
}

.PatientDetailsNavigation-module__header___j1s9N {
  height: var(--secondary-navigation);
  background-color: #fbf7f2;
  border-bottom: 1px solid #e6e7e8;
  justify-content: space-between;
  padding: 12px 20px 12px 30px;
  box-sizing: border-box;
}
.PatientDetailsNavigation-module__header___j1s9N .PatientDetailsNavigation-module__actionButton___YYLrl {
  border-width: 1px;
  padding: 3px;
}
.PatientDetailsNavigation-module__header___j1s9N .PatientDetailsNavigation-module__separator___K6g5N {
  min-height: 75%;
  width: 0;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/PatientDetailsNavigation/PatientDetailsNavigation.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sBAAA;AA8pBF;AA5pBE;EACE,iBAAA;EACA,YAAA;AA8pBJ;AA3pBE;EACE,eAAA;EACA,QAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.header {\n  height: var(--secondary-navigation);\n  background-color: get-color(orangeNew, light);\n  border-bottom: 1px solid get-color(gray, light);\n  justify-content: space-between;\n  padding: 12px 20px 12px 30px;\n  box-sizing: border-box;\n\n  .actionButton {\n    border-width: 1px;\n    padding: 3px;\n  }\n\n  .separator {\n    min-height: 75%;\n    width: 0;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `PatientDetailsNavigation-module__font-s-10___mxlze`,
	"fontS12": `PatientDetailsNavigation-module__font-s-12___L4wzv`,
	"fontS13": `PatientDetailsNavigation-module__font-s-13___hqXKI`,
	"fontS14": `PatientDetailsNavigation-module__font-s-14___AFIrC`,
	"fontS15": `PatientDetailsNavigation-module__font-s-15___lLlGR`,
	"fontS16": `PatientDetailsNavigation-module__font-s-16___nFvW9`,
	"fontS18": `PatientDetailsNavigation-module__font-s-18___Xdhpj`,
	"fontS20": `PatientDetailsNavigation-module__font-s-20___etu7O`,
	"fontS22": `PatientDetailsNavigation-module__font-s-22___QTtKe`,
	"fontS28": `PatientDetailsNavigation-module__font-s-28___hSuFY`,
	"fontW400": `PatientDetailsNavigation-module__font-w-400___WIqYk`,
	"fontW500": `PatientDetailsNavigation-module__font-w-500___Azq45`,
	"fontW600": `PatientDetailsNavigation-module__font-w-600___jO86B`,
	"fontW700": `PatientDetailsNavigation-module__font-w-700___qTATm`,
	"p5": `PatientDetailsNavigation-module__p-5___QbxwL`,
	"p12": `PatientDetailsNavigation-module__p-12___L5IPT`,
	"p16": `PatientDetailsNavigation-module__p-16___pkc_h`,
	"p30": `PatientDetailsNavigation-module__p-30___fffoF`,
	"pB0": `PatientDetailsNavigation-module__p-b-0___glRpy`,
	"pB5": `PatientDetailsNavigation-module__p-b-5___ZMKYP`,
	"pB10": `PatientDetailsNavigation-module__p-b-10___S6BXQ`,
	"pB12": `PatientDetailsNavigation-module__p-b-12___dkwTK`,
	"pB16": `PatientDetailsNavigation-module__p-b-16___voxdM`,
	"pB18": `PatientDetailsNavigation-module__p-b-18___i6Ff1`,
	"pB20": `PatientDetailsNavigation-module__p-b-20___zYscO`,
	"pB25": `PatientDetailsNavigation-module__p-b-25___lgvE4`,
	"pB30": `PatientDetailsNavigation-module__p-b-30___dDNLd`,
	"pB50": `PatientDetailsNavigation-module__p-b-50___jnAuX`,
	"pT0": `PatientDetailsNavigation-module__p-t-0___c2eU5`,
	"pT12": `PatientDetailsNavigation-module__p-t-12___SC5BQ`,
	"pT16": `PatientDetailsNavigation-module__p-t-16___AXPRw`,
	"pT18": `PatientDetailsNavigation-module__p-t-18___dOOuZ`,
	"pT20": `PatientDetailsNavigation-module__p-t-20___YgBkh`,
	"pT30": `PatientDetailsNavigation-module__p-t-30___x5sfX`,
	"pT40": `PatientDetailsNavigation-module__p-t-40___hwxhD`,
	"pT50": `PatientDetailsNavigation-module__p-t-50___k4F8a`,
	"pL20": `PatientDetailsNavigation-module__p-l-20___Evbvs`,
	"pL30": `PatientDetailsNavigation-module__p-l-30___L45sf`,
	"pL40": `PatientDetailsNavigation-module__p-l-40___GCLBb`,
	"pR16": `PatientDetailsNavigation-module__p-r-16___q7h6t`,
	"pR20": `PatientDetailsNavigation-module__p-r-20___9NJcT`,
	"pR30": `PatientDetailsNavigation-module__p-r-30___JBITQ`,
	"pR50": `PatientDetailsNavigation-module__p-r-50___LKOf0`,
	"pR60": `PatientDetailsNavigation-module__p-r-60___NvnK8`,
	"mB1": `PatientDetailsNavigation-module__m-b-1___ck8yS`,
	"mB2": `PatientDetailsNavigation-module__m-b-2___Nl3jY`,
	"mB6": `PatientDetailsNavigation-module__m-b-6___bOBTw`,
	"mB8": `PatientDetailsNavigation-module__m-b-8___u2Fq_`,
	"mB10": `PatientDetailsNavigation-module__m-b-10____fSAP`,
	"mB14": `PatientDetailsNavigation-module__m-b-14___xKFS9`,
	"mB16": `PatientDetailsNavigation-module__m-b-16___nt_oo`,
	"mB20": `PatientDetailsNavigation-module__m-b-20___EhWoa`,
	"mB22": `PatientDetailsNavigation-module__m-b-22___lHDcL`,
	"mB24": `PatientDetailsNavigation-module__m-b-24___ZcMLy`,
	"mB30": `PatientDetailsNavigation-module__m-b-30___WOsLS`,
	"mB32": `PatientDetailsNavigation-module__m-b-32___iBnqX`,
	"mB40": `PatientDetailsNavigation-module__m-b-40___ugcKS`,
	"mT2": `PatientDetailsNavigation-module__m-t-2___FVPzZ`,
	"mT3": `PatientDetailsNavigation-module__m-t-3___WSXos`,
	"mT4": `PatientDetailsNavigation-module__m-t-4___H58aA`,
	"mT5": `PatientDetailsNavigation-module__m-t-5___OfO4n`,
	"mT8": `PatientDetailsNavigation-module__m-t-8___PR6no`,
	"mT10": `PatientDetailsNavigation-module__m-t-10___i4iHY`,
	"mT15": `PatientDetailsNavigation-module__m-t-15___uvyxv`,
	"mT16": `PatientDetailsNavigation-module__m-t-16___0YEUM`,
	"mT20": `PatientDetailsNavigation-module__m-t-20___tOxrq`,
	"mT22": `PatientDetailsNavigation-module__m-t-22___mXaCM`,
	"mT30": `PatientDetailsNavigation-module__m-t-30___HGwpX`,
	"mT32": `PatientDetailsNavigation-module__m-t-32___zMWTm`,
	"mLAuto": `PatientDetailsNavigation-module__m-l-auto___jGMFy`,
	"mL4": `PatientDetailsNavigation-module__m-l-4___fsUCD`,
	"mL5": `PatientDetailsNavigation-module__m-l-5___ibEaC`,
	"mL6": `PatientDetailsNavigation-module__m-l-6___ODDAE`,
	"mL8": `PatientDetailsNavigation-module__m-l-8___uqEzH`,
	"mL10": `PatientDetailsNavigation-module__m-l-10___SxGw3`,
	"mL16": `PatientDetailsNavigation-module__m-l-16___DrN3j`,
	"mL20": `PatientDetailsNavigation-module__m-l-20___yW5DR`,
	"mL24": `PatientDetailsNavigation-module__m-l-24___QSD9G`,
	"mL30": `PatientDetailsNavigation-module__m-l-30___nI_DJ`,
	"mL35": `PatientDetailsNavigation-module__m-l-35___Q4MFF`,
	"mL40": `PatientDetailsNavigation-module__m-l-40___c6NtL`,
	"mR8": `PatientDetailsNavigation-module__m-r-8___MNxpb`,
	"mR10": `PatientDetailsNavigation-module__m-r-10___X8Pc5`,
	"mR16": `PatientDetailsNavigation-module__m-r-16___k8__s`,
	"mR20": `PatientDetailsNavigation-module__m-r-20___fqaVp`,
	"mR24": `PatientDetailsNavigation-module__m-r-24___O3TKx`,
	"mR30": `PatientDetailsNavigation-module__m-r-30___omjYl`,
	"mR40": `PatientDetailsNavigation-module__m-r-40___qXEoT`,
	"borderR3": `PatientDetailsNavigation-module__border-r-3___zZrUt`,
	"borderR4": `PatientDetailsNavigation-module__border-r-4___utR5G`,
	"borderR6": `PatientDetailsNavigation-module__border-r-6___GOA_J`,
	"borderR10": `PatientDetailsNavigation-module__border-r-10___OvcmH`,
	"borderR12": `PatientDetailsNavigation-module__border-r-12____FVfM`,
	"borderR16": `PatientDetailsNavigation-module__border-r-16___x8kLB`,
	"borderR50": `PatientDetailsNavigation-module__border-r-50___gvZ5d`,
	"primaryBorder": `PatientDetailsNavigation-module__primary-border___KU7_3`,
	"primaryBorderB": `PatientDetailsNavigation-module__primary-border-b___u4604`,
	"primaryBorderT": `PatientDetailsNavigation-module__primary-border-t___knzLf`,
	"primaryBorderL": `PatientDetailsNavigation-module__primary-border-l___iXNGF`,
	"primaryBorderR": `PatientDetailsNavigation-module__primary-border-r___RNFjg`,
	"secondaryBorder": `PatientDetailsNavigation-module__secondary-border___e61Ei`,
	"secondaryBorderB": `PatientDetailsNavigation-module__secondary-border-b___dU21F`,
	"secondaryBorderT": `PatientDetailsNavigation-module__secondary-border-t___UnVWW`,
	"secondaryBorderL": `PatientDetailsNavigation-module__secondary-border-l___m6mpk`,
	"secondaryBorderR": `PatientDetailsNavigation-module__secondary-border-r___Z96PU`,
	"gap0": `PatientDetailsNavigation-module__gap-0___fIUNr`,
	"gap2": `PatientDetailsNavigation-module__gap-2___QCUPh`,
	"gap4": `PatientDetailsNavigation-module__gap-4___wPaZa`,
	"gap5": `PatientDetailsNavigation-module__gap-5___Gwe5G`,
	"gap6": `PatientDetailsNavigation-module__gap-6___vrPiO`,
	"gap8": `PatientDetailsNavigation-module__gap-8___SY3Kr`,
	"gap10": `PatientDetailsNavigation-module__gap-10___O0KxY`,
	"gap12": `PatientDetailsNavigation-module__gap-12___faOFk`,
	"gap14": `PatientDetailsNavigation-module__gap-14___zoofE`,
	"gap16": `PatientDetailsNavigation-module__gap-16___J9o_4`,
	"gap18": `PatientDetailsNavigation-module__gap-18___CWfMS`,
	"gap20": `PatientDetailsNavigation-module__gap-20___cudxe`,
	"gap24": `PatientDetailsNavigation-module__gap-24___cE2SR`,
	"gap26": `PatientDetailsNavigation-module__gap-26___mYz4R`,
	"gap30": `PatientDetailsNavigation-module__gap-30___lO327`,
	"gap32": `PatientDetailsNavigation-module__gap-32___r4ZWa`,
	"gap40": `PatientDetailsNavigation-module__gap-40___hVZwG`,
	"gap50": `PatientDetailsNavigation-module__gap-50___OgvUY`,
	"flex1": `PatientDetailsNavigation-module__flex-1___MBqZT`,
	"flexNone": `PatientDetailsNavigation-module__flex-none___yGihL`,
	"flexColumn": `PatientDetailsNavigation-module__flex-column___HQ4SV`,
	"flexRow": `PatientDetailsNavigation-module__flex-row___LjyI4`,
	"verticallyCentered": `PatientDetailsNavigation-module__vertically-centered___Mt8wk`,
	"horizontallyCentered": `PatientDetailsNavigation-module__horizontally-centered___mHZ9T`,
	"horizontallyEnd": `PatientDetailsNavigation-module__horizontally-end___Xmqxj`,
	"verticallyStart": `PatientDetailsNavigation-module__vertically-start___ye9p_`,
	"spaceBetween": `PatientDetailsNavigation-module__space-between____Vu9W`,
	"flexWrap": `PatientDetailsNavigation-module__flex-wrap___gG4yg`,
	"height100": `PatientDetailsNavigation-module__height-100___r9UNh`,
	"width50": `PatientDetailsNavigation-module__width-50___PWd2_`,
	"width100": `PatientDetailsNavigation-module__width-100___RpitE`,
	"cursorPointer": `PatientDetailsNavigation-module__cursor-pointer___PqxD3`,
	"cursorNotAllowed": `PatientDetailsNavigation-module__cursor-not-allowed___GGjlU`,
	"absoluteCentered": `PatientDetailsNavigation-module__absolute-centered___uXNbd`,
	"absolute": `PatientDetailsNavigation-module__absolute___SEies`,
	"relative": `PatientDetailsNavigation-module__relative___sbPc2`,
	"fixed": `PatientDetailsNavigation-module__fixed___bFZHo`,
	"visible": `PatientDetailsNavigation-module__visible___XtzkF`,
	"invisible": `PatientDetailsNavigation-module__invisible___BiAvi`,
	"col90": `PatientDetailsNavigation-module__col-90___sNkfI`,
	"colAuto": `PatientDetailsNavigation-module__col-auto___HJHLZ`,
	"medicalTabs": `PatientDetailsNavigation-module__medical-tabs___FLqO0`,
	"medicalTableNew": `PatientDetailsNavigation-module__medical-table-new___XeHFh`,
	"noPagination": `PatientDetailsNavigation-module__no-pagination___MQ_Qx`,
	"medicalTableEmpty": `PatientDetailsNavigation-module__medical-table-empty___UkUr1`,
	"iconBtn": `PatientDetailsNavigation-module__icon-btn___dADUP`,
	"searchIcon": `PatientDetailsNavigation-module__search-icon___B2lE8`,
	"disableSelect": `PatientDetailsNavigation-module__disable-select___avU92`,
	"breakWord": `PatientDetailsNavigation-module__break-word___eqAxS`,
	"popupClearBtn": `PatientDetailsNavigation-module__popup-clear-btn___eIlX5`,
	"scrollMB20": `PatientDetailsNavigation-module__scroll-m-b-20___J3EZi`,
	"header": `PatientDetailsNavigation-module__header___j1s9N`,
	"actionButton": `PatientDetailsNavigation-module__actionButton___YYLrl`,
	"separator": `PatientDetailsNavigation-module__separator___K6g5N`
};
module.exports = ___CSS_LOADER_EXPORT___;
